@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'action') {
            <div class="flex justify-center items-center gap-3">
              <div *ngIf="column.key.select" class="icon-btn">
                @if (checkSelect(element)) {
                  @if (multiSelect) {
                    <mat-icon> check_box </mat-icon>
                  } @else {
                    <mat-icon> radio_button_checked </mat-icon>
                  }
                } @else {
                  @if (multiSelect) {
                    <mat-icon> check_box_outline_blank </mat-icon>
                  } @else {
                    <mat-icon> radio_button_unchecked </mat-icon>
                  }
                }
              </div>
            </div>
          } @else if (column.keyColumn == 'phone') {
            {{ element[column.key] | telefone }}
          } @else if (column.keyColumn == 'cpf') {
            {{ element[column.key] | cpf }}
          } @else if (column.keyColumn == 'cnpj') {
            {{ element[column.key] | cnpj }}
          } @else if (column.keyColumn == 'location_OD') {
            <!--            <b>Origem: </b>{{ element.origem }}<br />-->
            <!--            <b>Destino: </b>{{ element.destino }}-->
            <b>Origem</b><br />
            Cidade: {{ element.cidadeOrigem }}<br />
            Estado: {{ element.estadoOrigem }}<br />
            <b>Destino</b><br />
            Cidade: {{ element.cidadeDestino }}<br />
            Estado: {{ element.estadoDestino }}
            @if (element.paradas?.length > 0) {
              <div class="mt-2 pt-2 border-t border-gray-200">
                <b>Paradas ({{ element.paradas.length }})</b>
                @for (parada of element.paradas; track parada.id; let i = $index) {
                  <div class="text-xs leading-tight mt-1">
                    <span class="font-medium">{{ i + 1 }}.</span>
                    @if (parada.logradouro || parada.numero || parada.bairro) {
                      <div>
                        {{ parada.logradouro }}{{ parada.logradouro && parada.numero ? ', ' : '' }}{{ parada.numero }}{{ (parada.logradouro || parada.numero) && parada.bairro ? ' — ' : '' }}{{ parada.bairro }}{{ parada.complemento ? ' (' + parada.complemento + ')' : '' }}
                      </div>
                    }
                    @if (parada.cidade || parada.estado || parada.cep) {
                      <div class="text-gray-500">
                        {{ parada.cidade }}{{ parada.cidade && parada.estado ? '/' : '' }}{{ parada.estado }}{{ (parada.cidade || parada.estado) && parada.cep ? ' • CEP ' : (parada.cep ? 'CEP ' : '') }}{{ parada.cep }}
                      </div>
                    }
                  </div>
                }
              </div>
            }
          } @else if (column.keyColumn == 'servico_TS') {
            <b>Tipo: </b>{{ element.tipoServico }}<br />
            <b>Serviço: </b>{{ element.servico }}
          } @else if (column.keyColumn == 'vehicle_VM') {
            <b>Tipo veículo: </b>{{ element.tipoVeiculo }}<br />
            <b>Tipo motorista: </b>{{ element.tipoMotorista }}
          } @else if (column.keyColumn == 'custoExtra_HK') {
            <b>Hora: </b>{{ element.custoHoraExtra_formatado }}<br />
            <b>KM: </b>{{ element.custokmExtra_formatado }}
          } @else if (column.keyColumn == 'infoTariff') {
            <b>Perimetro urbano: </b>
            {{ element.perimetroUrbano == 'S' ? 'Sim' : 'Não' }}
            @if (element.isClient) {
              <div class="text-green-800">
                <b>Exclusivo cliente</b>
              </div>
            }
            <!--            <b>Standard: </b>{{ element.standard == 'S' ? 'Sim' : 'Não' }}-->
          } @else {
            {{ element[column.key] }}
          }
          <!--          @else if (column.keyColumn == 'typeTariff') {-->
          <!--            {{ element.tipoId == 1 ? 'tg.mob' : 'Cliente' }}-->
          <!--          } -->
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      [ngClass]="checkSelect(row) ? 'row-selected' : ''"
      *matRowDef="let row; columns: displayedColumns"
      (click)="selectItemEvent(row)"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}

<!--    <ng-container *ngFor="let column of columns;" matColumnDef="{{column.keyColumn}}">-->
<!--      <th mat-header-cell *matHeaderCellDef> {{ column.description }} </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        @if (column.keyColumn == 'action') {-->
<!--          <button mat-flat-button class="btn-tg w-1/5" >-->
<!--            Editar-->
<!--          </button>-->
<!--        } @else {-->
<!--          {{element[column.key]}}-->
<!--        }-->
<!--      </td>-->
<!--    </ng-container>-->
